// extracted by mini-css-extract-plugin
module.exports = {"screen-sm":"580","screen-md":"960","screen-mdp":"1136","screen-lg":"1440","screen-xl":"1600"};